var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDo = function SvgIconDo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M.414 15.131a12.02 12.02 0 0 0 8.456 8.456v-8.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M8.87.413A12.02 12.02 0 0 0 .412 8.87H8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.587 8.87A12.02 12.02 0 0 0 15.131.414V8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M15.13 23.587a12.02 12.02 0 0 0 8.457-8.456h-8.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M15.131 12a3.13 3.13 0 1 1-6.26 0c0-1.73 3.13-3.13 3.13-3.13s3.13 1.4 3.13 3.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M8.87 12a3.13 3.13 0 0 1 6.261 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.24 10.435v1.956a1.76 1.76 0 1 0 3.521 0v-1.956z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconDo;